import { Component, ViewChild } from '@angular/core';
import { BreadcrumbExceptionMapping } from '../../../../constants';
import { BreadCrumbItem } from '../../../../shared/models/breadcrumb-item';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'sce-core';
import { INITIALBREADALLORDER } from '../../../../features/control-tower/fleet-monitoring/fleet-monitoring-config';
import { catchError, map } from 'rxjs/operators';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SetNotificationService } from '../set-notification.service';
import { getTmsTenantId } from 'src/app/core/tms-config';
@Component({
  selector: 'lfwms-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
})
export class BreadcrumbComponent {
  public breadcrumbsArray: {}[]; // = [{ displayName: 'Home', route: '/home', id: 'home' }];
  public mapIconVis: any = window.location.pathname.indexOf('search') != -1;
  public bellIconVis: any =
    window.location.pathname.indexOf('notification') == -1;
  public notificationVis: boolean = false;
  public buttonModalVis: boolean = false;
  public showReadFlag: boolean = false;
  public displayDialog: boolean = false;
  public remark: any;
  public newsList: any;
  public newsCount: any;
  public dealData: any;
  public isFullScreenMap: boolean = false;
  @ViewChild('actionModal') actionModal: any;

  constructor(
    public navService: NavigationService,
    public resourceService: ResourceService,
    public alertService: AlertService,
    public http$: HttpClient,
    public SetNotificationService: SetNotificationService,
    public router: Router,
    public route: ActivatedRoute
  ) {
    navService.getNavigatedMenuIdBroadcast().subscribe((id: any) => {
      /* Subscribe to the navigation service so that whenever
        the menuId is changed refresh the component display */
      this.breadcrumbsArray = this.navService.getCurrentBreadCrumb();
      // if(id === 'home'){
      this.navService.resetBreadcrumb('home');
      this.breadcrumbsArray = INITIALBREADALLORDER;
      // } else {
      //     this.breadcrumbsArray = this.navService.getCurrentBreadCrumb();
      // }
    });
  }
  ngOnInit(): void {
    this.isFullScreenMap = window.location.href.includes('fleetmap');
    let that = this;
    var bellBtn = document.getElementById('bellBtn');
    var notificationModal = document.getElementById('notificationModal');
    window.onclick = function (event) {
      var buttonModal = document.getElementById('buttonModal');
      if (
        !(
          (notificationModal && notificationModal.contains(event.target)) ||
          (buttonModal && buttonModal.contains(event.target))
        )
      ) {
        that.buttonModalVis = false;
        that.notificationVis = false;
      }
      if (!event.target.classList.contains('itemActionIcon')) {
        that.handleItemActionVis({}, true);
      }
    };
    bellBtn.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    const params = {
      enableSort: 'Y',
      status: 'UNREAD',
    };
    this.search(params);
    this.SetNotificationService.handleReset.subscribe(res => {
      this.search(params);
    });
  }

  public search(value) {
    this.getList(value).subscribe(res => {
      this.newsList = res.content;
      this.newsList.forEach(item => {
        item.timestamp = this.getMessageTimeDescription(item.reportingDate);
      });
      console.log(this.newsList, 'newsList===================>');
    });
    this.getNewsCount().subscribe(res => {
      this.newsCount = res;
    });
  }

  public getList(value) {
    const params = value;
    var userinfo = JSON.parse(localStorage.getItem('user_info'));
    var countryKey = userinfo['userRestrictions'][0]['countryCode'];
    // debugger
    const url = `/htms/v1/${getTmsTenantId()}/fleet-alert-history/${countryKey}?page=0&size=50`;
    const response$: any = this.http$.post(url, JSON.stringify(params)).pipe(
      map((response: any) => {
        console.log(response);
        return response;
      }),
      catchError((error: any) => {
        this.alertService.error(error.message);
        return this.resourceService.get(error.message);
      })
    );
    return response$;
  }
  public getNewsCount() {
    var userinfo = JSON.parse(localStorage.getItem('user_info'));
    var countryKey = userinfo['userRestrictions'][0]['countryCode'];
    // debugger
    const url = `/htms/v1/${getTmsTenantId()}/fleet-alert-history/unread-count/${countryKey}`;
    const response$: any = this.http$.get(url).pipe(
      map((response: any) => {
        console.log(response);
        return response;
      }),
      catchError((error: any) => {
        this.alertService.error(error.message);
        return this.resourceService.get(error.message);
      })
    );
    return response$;
  }
  // Navigates through NavigationService
  public navigateTo(item: BreadCrumbItem, index: number) {
    /* JIRA LFWM-1627 Fix - If we are in primary search page,
    then the navigation from last breadcrumb should not allowed */
    if (
      index !== this.breadcrumbsArray.length - 1 ||
      BreadcrumbExceptionMapping.indexOf(item.id) > -1 ||
      (item['id'] &&
        (item['id'] === 'forwarder_dashboard' ||
          item['displayValue'] === 'Recipient Group' ||
          item['id'] === 'operation_dashboard'))
    ) {
      if (item['id'] || item['displayValue'] === 'Recipient Group') {
        if (item['displayValue'] === 'Recipient Group') {
          this.router
            .navigateByUrl('/home', { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl(
                '/home/notification/notification-recipient'
              );
            });
        } else if (item['id'] === 'operation_dashboard') {
          this.router
            .navigateByUrl('/home', { skipLocationChange: true })
            .then(() => {
              this.router.navigateByUrl(
                '/home/global-control/operation-dashboard'
              );
            });
        } else {
          this.navService.navigateByMenuId(item['id']);
        }
      } else if (item['route']) {
        const length = this.breadcrumbsArray.length;
        while (++index < length) {
          this.navService.removeLastBreadCrumbItem();
        }
        this.navService.navigateByUrl(item['route']);
      }
    }
  }
  public goToMap() {
    this.router.navigate(['/fleetmap']);
  }
  public handleViewnotification() {
    this.notificationVis = !this.notificationVis;
    this.buttonModalVis = false;
  }

  public showButtonModal() {
    this.buttonModalVis = !this.buttonModalVis;
  }
  public onSwitchChange(event) {
    console.log(event.checked);
    this.showReadFlag = event.checked;
    if (event.checked) {
      let params = {
        status: 'READ_NOT_P',
        enableSort: 'Y',
      };
      this.search(params);
    } else {
      const params = {
        enableSort: 'Y',
        status: 'UNREAD',
      };
      this.search(params);
    }
  }
  public handleNotiAction(type) {
    this.buttonModalVis = false;
    if (type === 'Notifications') {
      this.router.navigate([
        '/home/control-tower/fleet-monitoring/notification',
      ]);
    } else if (type === 'Read') {
      this.makeRead().subscribe(res => {
        if (this.showReadFlag) {
        }
        const params = {
          enableSort: 'Y',
          status: this.showReadFlag ? 'READ_NOT_P' : 'UNREAD',
        };
        this.search(params);
      });
    } else if (type === 'Unread') {
      this.makeUnRead().subscribe(res => {
        const params = {
          enableSort: 'Y',
          status: this.showReadFlag ? 'READ_NOT_P' : 'UNREAD',
        };
        this.search(params);
      });
    }
  }
  public makeRead() {
    var userinfo = JSON.parse(localStorage.getItem('user_info'));
    var countryKey = userinfo['userRestrictions'][0]['countryCode'];
    // debugger
    const url = `/htms/v1/${getTmsTenantId()}/fleet-alert-history/mark-all-unread-as-read/${countryKey}`;
    const response$: any = this.http$
      .put(url, JSON.stringify('READ_NOT_P'))
      .pipe(
        map((response: any) => {
          console.log(response);
          return response;
        }),
        catchError((error: any) => {
          this.alertService.error(error.message);
          return this.resourceService.get(error.message);
        })
      );
    return response$;
  }
  public makeUnRead() {
    var userinfo = JSON.parse(localStorage.getItem('user_info'));
    var countryKey = userinfo['userRestrictions'][0]['countryCode'];
    // debugger
    const url = `/htms/v1/${getTmsTenantId()}/fleet-alert-history/mark-all-read-as-unread/${countryKey}`;
    const response$: any = this.http$.put(url, JSON.stringify('UNREAD')).pipe(
      map((response: any) => {
        console.log(response);
        return response;
      }),
      catchError((error: any) => {
        this.alertService.error(error.message);
        return this.resourceService.get(error.message);
      })
    );
    return response$;
  }
  public handleViewMap() {}
  public getMessageTimeDescription(timestamp) {
    const now = Date.now();
    const timeDiff = now - timestamp;
    const timeDiffSeconds = Math.floor(timeDiff / 1000);
    if (timeDiffSeconds < 30) {
      return 'a few seconds';
    } else if (timeDiffSeconds < 60) {
      return 'within one minute';
    } else if (timeDiffSeconds < 5 * 60) {
      return 'A few minutes';
    } else {
      return timestamp.split('.')[0];
    }
  }

  public handleItemActionVis(item, flag) {
    if (!this.newsList) {
      return;
    }
    if (item.showFlag || flag) {
      this.newsList.map(item => {
        item.showFlag = null;
      });
    } else {
      this.newsList.map(item => {
        item.showFlag = null;
      });
      item.showFlag = true;
    }
  }

  public handleItemActionClick(flag, data) {
    let status = '';
    this.dealData = data;
    if (flag === 'Unwatch') {
      status = 'UNREAD';
    } else if (flag === 'Read') {
      status = 'READ_NOT_P';
    } else if (flag === 'Resolve') {
      this.displayDialog = true;
      return;
    } else if (flag === 'Detail') {
      return;
    } else if (flag === 'Notification') {
      status = 'DELETE';
    }
    const params = {
      status: status,
      remark: '-',
      fleetAlertHistoryList: [
        {
          id: data.id,
          objectVersionNumber: data.objectVersionNumber,
        },
      ],
    };
    const queryParams = {
      enableSort: 'Y',
      status: this.showReadFlag ? 'READ_NOT_P' : 'UNREAD',
    };
    this.changeStatusList(params).subscribe(res => {
      this.alertService.clearAll().success('Operation Successful');
      this.displayDialog = false;
      this.search(queryParams);
    });
  }
  public submit() {
    const params = {
      status: 'PROCESSED',
      remark: this.remark,
      fleetAlertHistoryList: [
        {
          id: this.dealData.id,
          objectVersionNumber: this.dealData.objectVersionNumber,
        },
      ],
    };
    const queryParams = {
      enableSort: 'Y',
      status: this.showReadFlag ? 'READ_NOT_P' : 'UNREAD',
    };
    this.changeStatusList(params).subscribe(res => {
      this.alertService.clearAll().success('Operation Successful');
      this.displayDialog = false;
      this.search(queryParams);
    });
  }
  public changeStatusList(value) {
    var userinfo = JSON.parse(localStorage.getItem('user_info'));
    var countryKey = userinfo['userRestrictions'][0]['countryCode'];
    const url = `/htms/v1/${getTmsTenantId()}/fleet-alert-history`;
    const response$: any = this.http$.put(url, JSON.stringify(value)).pipe(
      map((response: any) => {
        console.log(response);
        return response;
      }),
      catchError((error: any) => {
        console.log(error);
        this.alertService.error(error.message);
        return this.resourceService.get(error.message);
      })
    );
    return response$;
  }
}
